import { ArticleSection } from "@domain/lms/article/article";

export abstract class SectionController<T extends ArticleSection> {
	constructor(
		protected readonly sectionUpdater: (update: (section: T) => T) => void,
		public readonly removeSection: () => void
	) {}
}
